import { CustomFieldResourceType } from "@repo/app-types/entities/customField";
import { FeatureFlagKey } from "@repo/app-types/featureFlags/keys";
import { useAllUserCustomFieldDefinitionsQuery } from "../../../api/entities/userCustomField.js";
import { useIsFeatureFlagEnabled } from "../../../helpers/featureFlags/hooks.js";

/**
 * Whether the "Interview" custom field resource type should be offered in the
 * UI. Mirrors the gating of the "Hire" tab: it's available unless recruiting is
 * hidden for the company. We additionally keep it visible whenever interview
 * custom fields already exist, so pre-existing fields stay creatable and
 * filterable even when the flag is off. This is a client-only check.
 */
export function useShouldShowInterviewResourceType(): boolean {
  const isRecruitingEnabled = !useIsFeatureFlagEnabled(
    FeatureFlagKey.HideHireTab,
  );
  const { data: customFields } = useAllUserCustomFieldDefinitionsQuery();

  const hasExistingInterviewField = (customFields ?? []).some(
    (field) => field.resource_type === CustomFieldResourceType.INTERVIEW,
  );

  return isRecruitingEnabled || hasExistingInterviewField;
}
